import {
  CasEntityRHFSelect,
  CasEntitySelectProps,
} from 'src/compass/shared/components';

export function RHFLrpProcessorSelect(props: CasEntitySelectProps) {
  return CasEntityRHFSelect('Employee/LRPProcessor', props);
}
